<p>opening-balance works!</p>
